import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const editBonusModalSchema = yupResolver(
  yup.object({
    adjustment: yup
      .string()
      .required('Ajuste é obrigatório')
      .test('non-negative', 'O valor do Ajuste (%) deve ser maior ou igual a zero', (value) => {
        if (!value) return true
        const numValue = Number(value.replace(',', '.'))
        return !isNaN(numValue) && numValue >= 0
      }),
    observations: yup.string().required('Observações é obrigatória')
  })
)
